import {DetailLinesOrderItem, DetailLinesProductItem, UiMessage} from '@components/export';
import {useLabel} from '@/hooks/export';

export const DetailLines = (props: {
    mode: 'product' | 'order',
    lines: apiProductLine[] | apiOrderLine[],
    loading: boolean,
    additionalPaymentList: apiOrderLine[],

    onLineUpdate: (field: string, value: any, id: string) => void,
    onItemGoToOrder: (id: string) => void,
    onAdditionalPaymentAdd: (lineId: string, paymentId: string) => void,
}) => {
    const label = useLabel();

    return <div className={cmpClass}>
        {
            props.lines.length ?
                props.lines.map((line, i) => {
                    if (props.mode === 'order') {
                        return <DetailLinesOrderItem
                            line={line}
                            locked={props.loading}
                            key={i}
                            additionalPaymentList={props.additionalPaymentList}

                            onLineUpdate={(field, value) => props.onLineUpdate(field, value, line.id)}
                            onAdditionalPaymentAdd={(lineId, paymentId) => props.onAdditionalPaymentAdd(lineId, paymentId)}
                        />;
                    }

                    if (props.mode === 'product') {
                        return <DetailLinesProductItem
                            line={line}
                            locked={props.loading}
                            key={i}

                            onLineUpdate={(field, value) => props.onLineUpdate(field, value, line.id)}
                            onOrderClick={(id) => props.onItemGoToOrder(id)}
                        />;
                    }
                }) :
                <UiMessage type={'info'} text={label.noLines} />
        }
    </div>;
};

const cmpClass = 'detail-lines';
